import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", { class: "fs-6 text-muted fw-normal me-5" }, "Group by", -1)
const _hoisted_6 = { class: "card-toolbar flex-row align-content-center align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "las la-sync" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "card-body pt-0" }
const _hoisted_11 = { class: "text-nowrap" }
const _hoisted_12 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_13 = { class: "text-nowrap" }
const _hoisted_14 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_15 = { class: "text-nowrap" }
const _hoisted_16 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_17 = { class: "text-nowrap" }
const _hoisted_18 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_19 = { class: "text-nowrap" }
const _hoisted_20 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_21 = { class: "text-nowrap" }
const _hoisted_22 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_23 = { class: "text-nowrap" }
const _hoisted_24 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_25 = { class: "text-nowrap" }
const _hoisted_26 = {
  key: 0,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBox = _resolveComponent("FilterBox")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_Entitytable = _resolveComponent("Entitytable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_FilterBox, {
      onChanged: _cache[0] || (_cache[0] = 
      () => {
        _ctx.$refs.pingo.resetPage();
        _ctx.$refs.pingo.retrieveData();
      }
    ),
      applied_filters: _ctx.filters,
      show_date: true,
      show_tz: true
    }, null, 8, ["applied_filters"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_el_select, {
            modelValue: _ctx.filters.grouping,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.grouping) = $event)),
            class: "mb-2"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupingOptions, (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option.key,
                  label: option.name,
                  value: option.key
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.name), 1)
                  ]),
                  _: 2
                }, 1032, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_switch, {
            modelValue: _ctx.showPercentage,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPercentage) = $event)),
            "active-color": "#459aaa",
            "active-text": "Show Percentages",
            class: "me-10"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_switch, {
            modelValue: _ctx.filters.date_usage,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.date_usage) = $event)),
            "active-value": "activity_date",
            "inactive-value": "creation_date",
            "active-color": "#459aaa",
            "inactive-color": "#459aaa",
            "active-text": "Activity Date",
            "inactive-text": "Creation Date"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            class: "btn ms-5 btn-primary btn-sm",
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (this.$refs.pingo.downloadData()), ["prevent"]))
          }, [
            _hoisted_7,
            _createTextVNode(" Download ")
          ]),
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$refs.pingo.retrieveData()), ["prevent"])),
            class: "btn ms-5 btn-primary btn-sm"
          }, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_Entitytable, {
          ref: "pingo",
          "entity-name": "stats",
          "resource-name": "stats",
          "filter-data": _ctx.filters,
          "show-totals": true,
          "columns-data": _ctx.columnData,
          "allow-sort": true,
          onStartLoading: _ctx.startLoading,
          onEndLoading: _ctx.endLoading
        }, {
          "column-status": _withCtx((lead) => [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                class: _normalizeClass(['badge', lead.entity.status.class]),
                "data-kt-menu-trigger": "click",
                "data-kt-menu-placement": "bottom-end",
                "data-kt-menu-flip": "top-end"
              }, _toDisplayString(lead.entity.status.label), 3)
            ])
          ]),
          "column-sales": _withCtx((lead) => [
            _createElementVNode("span", _hoisted_11, [
              _createTextVNode(_toDisplayString(lead.entity.sales) + " ", 1),
              (_ctx.showPercentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(lead.entity.sales_percent) + "%) ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "column-hold": _withCtx((lead) => [
            _createElementVNode("span", _hoisted_13, [
              _createTextVNode(_toDisplayString(lead.entity.hold) + " ", 1),
              (_ctx.showPercentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (" + _toDisplayString(lead.entity.hold_percent) + "%) ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "column-rejected": _withCtx((lead) => [
            _createElementVNode("span", _hoisted_15, [
              _createTextVNode(_toDisplayString(lead.entity.rejected) + " ", 1),
              (_ctx.showPercentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (" + _toDisplayString(lead.entity.rejected_percent) + "%) ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "column-trash": _withCtx((lead) => [
            _createElementVNode("span", _hoisted_17, [
              _createTextVNode(_toDisplayString(lead.entity.trash) + " ", 1),
              (_ctx.showPercentage)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " (" + _toDisplayString(lead.entity.trash_percent) + "%) ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          "totals-trash": _withCtx((data) => [
            _createElementVNode("span", _hoisted_19, [
              _createElementVNode("b", null, [
                _createTextVNode(_toDisplayString(data.entity.totals[data.entity.columnName]) + " ", 1),
                (
                  _ctx.showPercentage &&
                  data.entity.totals[data.entity.columnName + '_percent']
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, " (" + _toDisplayString(data.entity.totals[data.entity.columnName + "_percent"]) + "%) ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          "totals-sales": _withCtx((data) => [
            _createElementVNode("span", _hoisted_21, [
              _createElementVNode("b", null, [
                _createTextVNode(_toDisplayString(data.entity.totals[data.entity.columnName]) + " ", 1),
                (
                  _ctx.showPercentage &&
                  data.entity.totals[data.entity.columnName + '_percent']
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, " (" + _toDisplayString(data.entity.totals[data.entity.columnName + "_percent"]) + "%) ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          "totals-hold": _withCtx((data) => [
            _createElementVNode("span", _hoisted_23, [
              _createElementVNode("b", null, [
                _createTextVNode(_toDisplayString(data.entity.totals[data.entity.columnName]) + " ", 1),
                (
                  _ctx.showPercentage &&
                  data.entity.totals[data.entity.columnName + '_percent']
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, " (" + _toDisplayString(data.entity.totals[data.entity.columnName + "_percent"]) + "%) ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          "totals-rejected": _withCtx((data) => [
            _createElementVNode("span", _hoisted_25, [
              _createElementVNode("b", null, [
                _createTextVNode(_toDisplayString(data.entity.totals[data.entity.columnName]) + " ", 1),
                (
                  _ctx.showPercentage &&
                  data.entity.totals[data.entity.columnName + '_percent']
                )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, " (" + _toDisplayString(data.entity.totals[data.entity.columnName + "_percent"]) + "%) ", 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["filter-data", "columns-data", "onStartLoading", "onEndLoading"])
      ])
    ])
  ], 64))
}